import { ComponentType } from '@angular/cdk/overlay';
import { Injectable, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { InfoModalComponent } from '@components/info-modal/info-modal.component';
import { ModalData } from '@modules/modal/interfaces';

@Injectable({
  providedIn: 'root',
})
export class ModalService {

  constructor(private readonly dialog: MatDialog) {
  }

  private open<T, D = any, R = any>(componentOrTemplateRef: ComponentType<T> | TemplateRef<T>, config?: MatDialogConfig<D>): MatDialogRef<T, R> {
    return this.dialog.open(componentOrTemplateRef, config);
  }

  infoModal(data: ModalData, bgClose: boolean = false): MatDialogRef<InfoModalComponent> {
    return this.open(InfoModalComponent, { data, disableClose: bgClose, panelClass: ['isap-modal'] });
  }
}
